<template>
  <section class="cityface">
    <div id="canvas"></div>
  </section>
</template>

<script>
import Faces from '@/scripts/faces';

export default {
  name: 'cityFace',

  data() {
    return {
      entered: false,
    };
  },

  mounted() {
    this.intersectionObserver = new IntersectionObserver((entries) => {
      if (this.entered) this.faces.stop();
      if (entries[0].intersectionRatio <= 0) return;
      if (!this.entered) {
        this.init();
        this.entered = true;
      } else {
        this.faces.play();
      }
    });

    this.intersectionObserver.observe(this.$el);
  },

  beforeDestroy() {
    setTimeout(() => {
      this.faces.destroy();
    }, 1400);
  },

  methods: {
    init() {
      this.faces = new Faces({
        cols: 4,
        elements: 12,
        urlImg: '/static/img/faces/faceoftheworld.png',
        callback: this.setScale,
        mouseXScale: 0.005,
        mouseYScale: 0.008,
        mouseZScale: 0, // Don't move the face on the z axis
        facesIteration: 2,
        perspective: 1000,
        sceneScale: 1.3,
        mobileSceneScale: 1.5,
      });
    },

    setScale() {
      const el = this.faces.ctx;

      el.style.transform = 'scale(1)';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/colors';
@import '../application';

.cityface {
  position: relative;
  width: 100%;
  height: 100vh;
  margin: 0;

  @media only screen 
  and (device-width : 375px) 
  and (device-height : 812px) 
  and (-webkit-device-pixel-ratio : 3) {
    max-height: 680px;
  }

  @include mq(sm) {
    margin: 40px 0;
  }

  background-color: transparent;

  overflow: hidden;

  #canvas {
    position: absolute;
    width: 100%;
    height: 100%;

    pointer-events: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/WorldFace.vue